<rb-header-bar></rb-header-bar>
<rb-env-bar [eutrDocument]="eutrDocument"></rb-env-bar>
<rb-action-bar *ngIf="eutrDocument && userService.getUser()" [eutrDocument]="eutrDocument"></rb-action-bar>
